export const formatNumber = ( value ) => {

    // Formatar número para o formato brasileiro, caso seja 1000 deve ser formatado para 1.000 e caso seja 1000.50 deve ser formatado para 1.000,50
    const numValue = typeof value === 'string' ? parseFloat( value ) : value;

    if ( isNaN( numValue ) ) return '';

    return numValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });

}